module.exports = __webpack_public_path__ + "assets/cover_2_LQ-373b16.jpg";


/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/Content/images/cover_2_LQ.jpg
 ** module id = 919
 ** module chunks = 2
 **/